var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9939 17.3192V22.0119",
    stroke: "#000000",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16821 22.3443C10.7571 21.9011 13.2305 21.9011 15.8193 22.3443",
    stroke: "#000000",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48545 2.59942C7.6107 1.97027 9.8054 1.6557 12.0001 1.6557C14.1948 1.6557 16.3895 1.97028 18.5147 2.59943C18.5562 6.10209 18.2033 9.51577 17.4483 12.9717C16.99 15.07 15.5055 16.8729 13.4572 17.2008C12.4703 17.3586 11.5299 17.3586 10.5431 17.2008C8.49471 16.8729 7.01035 15.07 6.55193 12.9717C5.79692 9.51577 5.44397 6.10209 5.48545 2.59942Z",
    stroke: "#000000",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33058 12.0456H5.62539C4.65825 11.8424 3.7585 11.2778 3.05534 10.4174C2.15922 9.32088 1.65579 7.83366 1.65579 6.28294L1.65576 4.40335C1.65576 4.22805 1.7556 4.06805 1.91307 3.99101C5.09517 2.43414 8.5476 1.6557 12 1.6557C15.4525 1.6557 18.9049 2.43414 22.087 3.99101C22.2446 4.06805 22.3443 4.22805 22.3443 4.40335V6.28294C22.3443 7.83366 21.8408 9.32088 20.9448 10.4174C20.2416 11.2778 19.3418 11.8424 18.3747 12.0456H17.6695",
    stroke: "#000000",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenges);
export default __webpack_public_path__ + "static/media/challenges.72189dce22db025ef6d243a28b4e1fa4.svg";
export { ForwardRef as ReactComponent };